<template>
  <div>
    <div class="selectPlan">
      <div class="selectPlan__customize">
        <ul class="selectPlan__customize-list">
          <li class="included" v-for="(include, index) of includes" :key="index">
            {{ include.name }}
          </li>
        </ul>
        <div class="selectPlan__price">
          <div v-if="discount" class="selectPlan__price_old">
            <span class="selectPlan__price_old_bold">{{ $t('renew.price.qar') }}</span>&nbsp;
            <span class="selectPlan__price_old_regular">{{ $options.filters.splitNumber(priceFrom + discount) }}</span>
          </div>
          <div class="selectPlan__price_base">
            <span class="selectPlan__price_base_regular">{{ $t('renew.price.from') }}</span>&nbsp;
            <span class="selectPlan__price_base_bold">{{
                $t('renew_qar', { price: $options.filters.splitNumber(priceFrom) })
              }}</span>
          </div>
        </div>
        <i class="selectPlan__installment">
          {{ $t('select_plan_installment', { installment: installmentPrice }) }} <i
            @click="togglePopupMore">{{ $t('renew.learn_more') }}</i>
        </i>
      </div>
      <BaseButton @click.prevent="$emit('submit')"/>
      <BasePopupWrapper :popupBig="true" @close="togglePopupMore" v-if="showMoreInfo">
        <div class="installment-select-plan__popup">
          <h3>{{ $t('qic_installment_popup.title') }}</h3>
          <h4>{{ $t('qic_installment_popup.heading_1') }}</h4>
          <p>{{ $t('qic_installment_popup.text_1_1') }}</p>
          <h4>{{ $t('qic_installment_popup.heading_2') }}</h4>
          <p>{{ $t('qic_installment_popup.text_2_1') }}</p>
          <p>{{ $t('qic_installment_popup.text_2_2') }}</p>
          <p>{{ $t('qic_installment_popup.text_2_3') }}</p>
          <h4>{{ $t('qic_installment_popup.heading_3') }}</h4>
          <p>{{ $t('qic_installment_popup.text_3_1') }}
            <a href="/assets/pdf/Motor_Terms_And_Conditions_Installment.pdf" target="_blank">
              {{ $t('qic_installment_popup.text_3_1_link') }}
            </a>
          </p>
          <p>{{ $t('qic_installment_popup.text_3_2') }}</p>
        </div>
        <template v-slot:button>
          <base-button symbol="no" class="btn-second btn-second_medium" @click="togglePopupMore">
            {{ $t('qic_close') }}
          </base-button>
        </template>
      </BasePopupWrapper>
    </div>
  </div>
</template>

<script>
import { BasePopupWrapper } from 'qic-components'

export default {
  name: 'MotorOdPlanForm',
  components: {
    BasePopupWrapper
  },
  props: {
    includes: { type: Array, default: () => [] },
    priceFrom: { type: Number },
    installmentPrice: { type: Number },
    minDiscount: { type: Number },
    discount: Number
  },
  data () {
    return {
      showMoreInfo: false
    }
  },
  methods: {
    togglePopupMore () {
      this.showMoreInfo = !this.showMoreInfo
      const body = document.querySelector('body')
      const overflowHidden = 'overflow-off'
      if (this.showMoreInfo) {
        body.classList.add(overflowHidden)
      } else {
        body.classList.remove(overflowHidden)
      }
    }
  },
  emit: ['submit']
}
</script>

<style lang="scss">
.selectPlan__installment {
  font-size: 14px;
  line-height: 24px;
  display: block;
  color: rgba(82, 108, 130, 0.8);

  i {
    color: #5927FF;
    cursor: pointer;
    margin-inline-start: 8px;
  }

  @media (max-width: 550px) {
    font-size: 12px;
    line-height: 16px;
  }
}

.installment-select-plan {
  &__popup {
    overflow: scroll;
    max-height: 70vh;

    &::-webkit-scrollbar {
      height: 0;
      width: 0;
      display: none;
    }

    h3 {
      font-size: 40px;
      line-height: 48px;
      color: #1c1c1c;
      text-align: center;
      font-weight: 500;
      margin-bottom: 32px;
      @media (max-width: 550px) {
        font-size: 32px;
        line-height: 40px;
      }
    }

    h4 {
      font-weight: 500;
      font-size: 28px;
      line-height: 36px;
      color: #1C1C1C;
      margin-top: 24px;
    }

    p {
      font-size: 16px;
      line-height: 24px;
      color: rgba(82, 108, 130, 0.8);
      margin-top: 24px;
      @media (max-width: 550px) {
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
}
</style>
